var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 3.8125C-4.76562 4.95625 -4.76562 56.0438 30.5 57.1875C65.7656 56.0438 65.7656 4.95625 30.5 3.8125Z",
    fill: "#8BC34A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1778 22.6846L26.6872 41.1752C25.9247 41.9377 24.7809 41.9377 24.0184 41.1752L15.8216 32.9783C14.1059 31.2627 16.7747 28.594 18.4903 30.3096L25.3528 37.1721L42.5091 20.0158C44.2247 18.1096 46.8934 20.969 45.1778 22.6846Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.b15451eb19d6b9b4aff27d489a5393bf.svg";
export { ForwardRef as ReactComponent };